/* eslint-disable react/no-danger */
import { gettext } from '@eventbrite/i18n';
import { Button, Typography } from '@eventbrite/marmalade';
import React from 'react';
import './pricingAndPackagingHeroNew.scss';
import './rightSizePricingHero.scss';

const ContentWrapper = (props: React.PropsWithChildren<{}>) => (
    <div className="rsp-hero__bg-container">{props.children}</div>
);

export const PricingAndPackagingHero: React.FC = () => (
    <section className="pricing-and-packaging-hero">
        <ContentWrapper>
            <div className="pricing-and-packaging-hero-container">
                <header className="pricing-and-packaging-hero-container-header">
                    <h1>{gettext('Flexible plans that grow with you')}</h1>
                    <Typography as="p" color="#39364F" variant="body-lg">
                        {gettext(
                            'Create your event on the world’s largest and most trusted events marketplace. We’ve got everything you need to sell tickets, manage your events, and attract new attendees all in one place.',
                        )}
                    </Typography>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            width: '300px',
                        }}
                    >
                        <Button
                            onClick={() => {
                                window.location.href =
                                    '/signin/signup/?referrer=%2Fmanage%2Fevents%2Fcreate%2F';
                            }}
                            size="responsive"
                            variant="primary"
                        >
                            {gettext('Get started for free')}
                        </Button>
                    </div>
                </header>
            </div>
        </ContentWrapper>
    </section>
);

export default PricingAndPackagingHero;
